export interface BuildInfo {
  version: string;
  environment: string;
  commitSha: string;
}

// Logs version/environment/commit info to the devtools console on load — not
// rendered in the UI. Lets QA confirm exactly what they're looking at
// (version vs. tickets, which env, which commit) without cluttering the page.
export function logBuildInfo({ version, environment, commitSha }: BuildInfo) {
  const shortSha = commitSha ? commitSha.slice(0, 7) : 'local dev';

  // eslint-disable-next-line no-console
  console.info(
    '%c Moveris Dev Portal %c',
    'background:#CF7629;color:#fff;font-weight:bold;padding:2px 6px;border-radius:3px;',
    'background:transparent;',
    `\n• Version: ${version}\n• Environment: ${environment}\n• Commit: ${shortSha}`,
  );
}
